import React from "react";
import { Button, message, Modal } from "antd";
import globalStore from "@/store";
import StorageManager from "@/utils/StorageManager";
import {
    errorModalWitheUrlList,
    FD_BASE_URL,
    hiddenLoginExpiryModalPathname,
    retailerLoginUrl,
    supplierLoginUrl,
    WeChatUrl,
} from "@/config";
import ShopType from "@/enum/ShopType";
import { openSendAuthUrlModal } from "@qn/utils/dialog";
import { qqService, wangwangService, weChatService } from "../customerServices";
import ProxyImage from "@/components/ProxyImage";
import copy from "copy-to-clipboard";
import {
    apiShopTypes,
    buildShopReAuthRedirectUrlAndToken,
    EcMarketShopTypes,
    getLogoutPlatformUrl,
    hasNoReAuthButtonShopTypes,
    YouZanAuthLink,
} from "@/utils/ShopUtils";
import EwaybillType from "@/enum/EwaybillType";
import EwaybillTypeNameMap from "@/map/EwaybillTypeNameMap";
import AutoLoadingButton from "@/components/AutoLoadingButton";
import { syncShopSubscription } from "@/services/api/shop";
import { PremiumFunctionType } from "../PremiumValidator";
import ShopDTO from "@/dto/shop/ShopDTO";
import { getSETokenFromQn } from "@qn/services/api/getToken";
import AppVersionNameMap from "@/map/AppVersionNameMap";
import {
    findOrderVolumeBestQuantity,
    getOrderVolumeLimit,
    getOrderVolumeTipName,
} from "@/scenes/setting/Shop/OrderVolume/services";
import AppVersion from "@/enum/AppVersion";

import OrderVolumePurchaseModal from "@/scenes/setting/Shop/OrderVolume/PurchaseModal";
import {
    getPrepaidAccount,
    syncFirstPagePrepaidAccountPaymentStatus,
    syncTbPrePaidAccountOrder,
} from "../api/prepaidAccount";
import { purchaseOrderVolume } from "../api/orderVolume";
import ShopTypeNameMap from "@/map/ShopTypeNameMap";
import { openUrl } from "@/utils";
import DyEwaybillAuthModal from "@/scenes/setting/EwaybillAccount/components/EwaybillAccountOperation/components/DyEwaybillAuthButton/DyEwaybillAuthModal";
import { getSubscribeUrlByShopSetting } from "../subscribeServices";

export interface EWaybillAccountInvalidResponseData {
    ewaybillAccountId: number;

    ewaybillType: EwaybillType;

    platformUsername: string;
}

export interface ShopExpiredResponseData {
    shopId?: number;
}

// 模态框引用
let modalRef: ReturnType<typeof Modal.error> = null;

function onWeChatClick() {
    modalRef?.destroy();

    Modal.info({
        title: <div className="tc">扫码发起聊天</div>,
        icon: false,
        width: 520,
        content: (
            <div className="tc">
                <img src={weChatService?.url} />

                <p className="mt10 text-gray">扫码关注公众号后,点击页面底部的「联系客服」发送消息</p>

                <div style={{ display: "flex", justifyContent: "space-around", marginTop: 10 }}>
                    <Button
                        type="link"
                        onClick={() => {
                            window.open(WeChatUrl, "_blank");
                        }}
                    >
                        点击直接电脑端微信联系客服
                    </Button>

                    <Button
                        type="link"
                        href="https://qw15p3s8hv.feishu.cn/wiki/MzUjwDE6KiL3AAkeJolcRMzonvb"
                        target="_blank"
                    >
                        点击查看更多电脑端微信联系客服方法
                    </Button>
                </div>
            </div>
        ),
    });
}

export function buildService() {
    return (
        <p className="mt5">
            {weChatService && (
                <a
                    target="_blank"
                    onClick={(e) => {
                        e.stopPropagation();

                        onWeChatClick();
                    }}
                    className="mr10"
                >
                    <ProxyImage src={weChatService.icon} alt="点击这里给我发消息" title="点击这里给我发消息" />
                </a>
            )}

            <a target="_blank" href={wangwangService.url} className="mr10">
                <ProxyImage src={wangwangService.icon} alt="点击这里给我发消息" title="点击这里给我发消息" />
            </a>

            {qqService && (
                <a target="_blank" href={qqService.url}>
                    <ProxyImage src={qqService.icon} alt="点击这里给我发消息" title="点击这里给我发消息" />
                </a>
            )}
        </p>
    );
}

function buildServiceContent(text?) {
    const serviceContent = (
        <div>
            {text ? (
                <p className="mt5">
                    <a
                        href="#"
                        onClick={(e) => {
                            e.stopPropagation();

                            copy(text);
                        }}
                    >
                        复制错误信息
                    </a>
                </p>
            ) : null}

            {buildService()}
        </div>
    );

    return serviceContent;
}

// 显示错误弹框， 阻断操作
export function showErrorModal(title = "错误信息", msg = "错误代码： 1") {
    const serviceContent = buildServiceContent(msg);

    if (!modalRef) {
        modalRef = Modal.error({
            title,
            content: (
                <div>
                    <div dangerouslySetInnerHTML={{ __html: msg }} />

                    {serviceContent}
                </div>
            ),
            onCancel() {
                modalRef = null;
            },
            onOk() {
                modalRef = null;
            },
        });
    } else {
        modalRef.update({
            content: (
                <div>
                    <div dangerouslySetInnerHTML={{ __html: msg }} />

                    {serviceContent}
                </div>
            ),
        });
    }
}

export function showNetworkErrorModal(title = "网络请求错误", error) {
    const serviceContent = buildServiceContent();

    const errorMessage = error?.message || "请检查您的网络设置，请求发送失败！";
    const requestUrl = error?.config?.url || "";

    const search = new URLSearchParams(location.search);
    const reload = search.get("reload");

    if (reload) {
        const commonProps = {
            title,
            okText: "查看网络错误解决教程",
            okCancel: true,
            cancelText: "关闭",
            onCancel() {
                modalRef = null;
            },
            onOk() {
                openUrl("https://qw15p3s8hv.feishu.cn/wiki/wikcnOPF4r0tedEzh2QHDdyE4uc");

                modalRef = null;
            },
            content: (
                <div>
                    <p>请联系客服或者查看网络错误解决办法教程</p>
                    <div className="text-gray fs12 mt20">
                        <p>{errorMessage}</p>
                        <p>path:{requestUrl}</p>
                        <p>server:{error?.config?.baseURL}</p>
                        <p>timestamp:{error?.config?._requestId}</p>
                    </div>
                    {serviceContent}
                </div>
            ),
        };

        if (!modalRef) {
            modalRef = Modal.error({
                ...commonProps,
            });
        } else {
            modalRef.update({
                ...commonProps,
            });
        }
    } else {
        const commonProps = {
            title,
            okText: "刷新页面",
            okCancel: true,
            onCancel() {
                modalRef = null;
            },
            onOk() {
                search.append("reload", "1");
                location.search = search.toString();

                modalRef = null;
            },
            content: (
                <div>
                    <p>请尝试刷新页面</p>
                    <div className="text-gray fs12 mt20">
                        <p>{errorMessage}</p>
                        <p>path:{requestUrl}</p>
                        <p>server:{error?.config?.baseURL}</p>
                        <p>timestamp:{error?.config?._requestId}</p>
                    </div>

                    {serviceContent}
                </div>
            ),
        };

        if (!modalRef) {
            modalRef = Modal.error({
                ...commonProps,
            });
        } else {
            modalRef.update({
                ...commonProps,
            });
        }
    }
}

// 登录过期弹窗
export function showLoginExpiryModal() {
    const value = StorageManager.getLoginView();

    const loginUrl = value === "supplier" ? supplierLoginUrl : retailerLoginUrl;

    // 登录过期 path在/order/list 刷新页面后 重定向至登录页面 添加延时判断 是否需要弹框
    setTimeout(() => {
        const pathname = window.location.pathname;

        const isShowModal = !hiddenLoginExpiryModalPathname.some((it) => it === pathname);

        if (isShowModal) {
            const info = {
                title: "登录过期，请重新登录",
                okText: "去登录",
                onOk() {
                    if (import.meta.env.VITE_IS_QN) {
                        window.open(loginUrl, "_blank");
                    } else {
                        window.open(loginUrl, "_self");
                    }
                },
            };

            if (!modalRef) {
                modalRef = Modal.error(info);
            } else {
                modalRef.update(info);
            }
        }
    }, 17);
}

let reAuthModalRef: ReturnType<typeof Modal.confirm> = null;
let openAuthModalLoading = false;
/**
 * 店铺授权过期弹框 （例：拼多多）
 */
export const showShopReAuthModal = async (data?: { shopId: number }) => {
    if (reAuthModalRef || openAuthModalLoading) {
        return;
    }
    openAuthModalLoading = true;

    const shopId = data?.shopId;

    const shop = globalStore.shopMapping.get(shopId);

    const shopName = shop?.name;
    const shopType = shop?.type;

    try {
        if (apiShopTypes.includes(shopType)) {
            let url = "";

            if (shop.type === ShopType.FKW) {
                url = "https://i.fkw.com/";
            } else if (shop.type === ShopType.WSC) {
                url = "https://adm.webportal.top/";
            } else if (shop.type === ShopType.SDMM) {
                url = "https://v2.fahuoyi.com/login";
            } else if (shop.type === ShopType.FKMDT) {
                url = "https://i.yk.fkw.com/#/order/sender-easy";
            } else if (shop.type === ShopType.HKMDXT) {
                url = "https://yk.webportal.top/#/order/sender-easy";
            }

            reAuthModalRef = Modal.confirm({
                title: "店铺授权",
                closable: true,
                content: (
                    <div>
                        店铺<span className="text-primary">{shopName}</span>
                        授权已过期，请点击下面的“去登录”按钮去网站后台—“订单”—“快速订单”—“前往打单”重新进入发货易软件。
                    </div>
                ),
                okText: "去登录",
                onOk() {
                    if (url) {
                        window.open(url, "_self");
                    }
                },
                onCancel() {
                    reAuthModalRef = undefined;
                },
            });
        } else if (
            [ShopType.CHANNEL_SHOP, ShopType.CHANNEL_SHOP_DROPSHIP, ShopType.CHANNEL_SHOP_SUPPLIER].includes(shopType)
        ) {
            reAuthModalRef = Modal.confirm({
                title: "店铺授权",
                closable: true,
                content: (
                    <div>
                        <div>
                            店铺<span className="text-primary">{shopName}</span>
                            授权已过期，请点击下面的“去登录”按钮去微信小店网站后台登录，登录后进入“服务市场”，进入“我的服务-使用中”，找到“发货易软件”点击“去使用”
                        </div>
                        <div className="mt5">
                            <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnfryAMOthFoFlT84F5yYr2b" target="_blank">
                                点击这里可查看教程
                            </a>
                        </div>
                    </div>
                ),
                okText: "去登录",
                onOk() {
                    if (ShopType.CHANNEL_SHOP === shopType) {
                        window.open("https://store.weixin.qq.com/shop/servicemarket/myServices?status=0", "_self");
                    } else {
                        window.open("https://store.weixin.qq.com/supplier/servicemarket/myServices?status=0", "_self");
                    }
                },
                onCancel() {
                    reAuthModalRef = undefined;
                },
            });
        }
        // 没有重新授权按钮的店铺
        else if (hasNoReAuthButtonShopTypes.includes(shopType)) {
            Modal.error({
                title: "店铺授权过期",
                content: (
                    <div>
                        店铺<span className="text-primary">{shopName}</span>
                        授权已过期，请重新授权登录。
                    </div>
                ),
            });
        } else {
            // 原因api和拦截器产生循环引用，vite esm原生模块开发环境暂不支持
            // 故此处使用动态引入方式
            const { reAuth } = await import("@/services/api/shop");

            const { token, redirectUrl } = await buildShopReAuthRedirectUrlAndToken();

            const isQN = import.meta.env.VITE_IS_QN;

            let { oauthUrl } = await reAuth(shopId, token, redirectUrl);

            oauthUrl = getLogoutPlatformUrl(shopType, oauthUrl);

            reAuthModalRef = Modal.confirm({
                title: "店铺授权",
                closable: true,
                content: (
                    <div>
                        店铺<span className="text-primary">{shopName}</span>授权已过期，请点击下面的“重新授权”按钮用
                        <span className="text-primary">{shopName}</span>
                        登录授权。授权成功后点击下方的“授权完成”按钮关闭窗口，继续你的操作
                        {shopType === ShopType.WEIDIAN ? (
                            <div className="error text-small">
                                微店服务市场订购发货易过期会导致频繁授权，
                                <a
                                    target="_blank"
                                    href="https://qw15p3s8hv.feishu.cn/wiki/YBeOwZYihiEfaKkgUsxcw7lUnny?from=from_copylink"
                                >
                                    点击查看解决方案
                                </a>
                            </div>
                        ) : null}
                    </div>
                ),
                okText: "请点击这里重新授权",
                cancelText: "授权完成",
                onOk() {
                    const authShop = globalStore.shopMapping.get(shopId);

                    const authShopType = authShop?.type;

                    if (authShopType === ShopType.YOUZAN) {
                        window.open(YouZanAuthLink, "_blank");

                        return;
                    }

                    const nick = authShop?.sellerUsername;

                    if (
                        isQN &&
                        (authShopType === ShopType.TAOBAO || authShopType === ShopType.TAOBAO_DISTRIBUTION) &&
                        shopId !== globalStore?.currentUser?.shopId
                    ) {
                        openSendAuthUrlModal(oauthUrl, nick);
                    } else {
                        window.open(oauthUrl, "_blank");

                        return Promise.reject();
                    }

                    reAuthModalRef = undefined;
                },
                onCancel() {
                    reAuthModalRef = undefined;
                },
            });
        }
    } finally {
        openAuthModalLoading = false;
    }
};

/**
 *  根据请求url是否显示错误提示框
 */
export function getIsShowErrorModal(requestUrl: string) {
    return !errorModalWitheUrlList.find((it) => requestUrl.startsWith(it));
}

export function showLargeFileErrorModal() {
    showErrorModal("发送请求失败", "上传文件过大");

    return Promise.reject("上传文件过大");
}

let ewaybillAccountReAuthModalRef: ReturnType<typeof Modal.confirm> = null;

export async function showEwaybillAccountReAuthModal(data: EWaybillAccountInvalidResponseData) {
    const { ewaybillAccountId, ewaybillType, platformUsername } = data;

    if (ewaybillAccountReAuthModalRef || !ewaybillAccountId) return;

    const { buildReAuthUrl } = await import("@/services/api/ewaybillAuth");

    ewaybillAccountReAuthModalRef = Modal.confirm({
        title: "电子面单授权",
        closable: true,
        content: (
            <div>
                电子面单账号
                <span className="text-primary">
                    {platformUsername}[{EwaybillTypeNameMap[ewaybillType]}]
                </span>
                授权过期,请点击下面的重新授权按钮进行授权。授权成功后点击下方的“授权完成”按钮关闭窗口，继续你的操作
            </div>
        ),
        okText: "请点击这里重新授权",
        cancelText: "授权完成",
        async onOk() {
            if (ewaybillType === EwaybillType.JINRITEMAI_AUTH) {
                globalStore.modalStore.openModal(DyEwaybillAuthModal);

                ewaybillAccountReAuthModalRef = null;
            } else {
                const { url } = await buildReAuthUrl(ewaybillAccountId);

                window.open(url, "_blank");

                ewaybillAccountReAuthModalRef = null;
            }
        },
        onCancel() {
            ewaybillAccountReAuthModalRef = null;
        },
    });
}

export function showShopExpiredModal(data: ShopExpiredResponseData) {
    const shopId = data?.shopId;

    const shop = globalStore.shopMapping.get(shopId);

    if (!shop) {
        const instance = Modal.info({
            title: (
                <span>
                    店铺已过期，需要续费后才能继续使用，或将手工店铺转移到其他平台店铺下，可
                    <a href="https://v2.fahuoyi.com/cs" target="_blank" rel="noopener noreferrer">
                        联系客服
                    </a>
                    转移手工店铺
                </span>
            ),
            content: (
                <div>
                    <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "-20px", marginTop: 40 }}>
                        <Button
                            className="mr10"
                            onClick={() => {
                                instance.destroy();
                            }}
                        >
                            取消
                        </Button>

                        <AutoLoadingButton
                            type="primary"
                            onClick={async () => {
                                let href = "";

                                if (import.meta.env.VITE_IS_QN) {
                                    const token = await getSETokenFromQn();

                                    href = `${FD_BASE_URL}/setting/shop?_token_=${token}`;
                                } else {
                                    href = `${FD_BASE_URL}/setting/shop`;
                                }

                                window.open(href, "_blank");
                            }}
                        >
                            去续费
                        </AutoLoadingButton>
                    </div>
                </div>
            ),
            okButtonProps: {
                hidden: true,
            },
            cancelButtonProps: {
                hidden: true,
            },
        });

        return;
    }

    const ownerShop = globalStore.shopMapping.get(shop?.ownerShopId);

    const instance = Modal.info({
        title: (
            <span>
                【{shop.name}】店铺已过期，需要续费后才能继续使用，或将手工店铺转移到其他平台店铺下，可
                <a href="https://v2.fahuoyi.com/cs" target="_blank" rel="noopener noreferrer">
                    联系客服
                </a>
                转移手工店铺
            </span>
        ),
        content: (
            <div>
                {shop && ownerShop ? (
                    <span className="text-error">
                        【{shop.name}】店铺所属店铺为【{ownerShop.name}】店铺，续费【{ownerShop.name}】店铺即可
                    </span>
                ) : null}

                <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "-20px", marginTop: 40 }}>
                    <Button
                        className="mr10"
                        onClick={() => {
                            instance.destroy();
                        }}
                    >
                        取消
                    </Button>

                    <AutoLoadingButton
                        className="mr10"
                        onClick={async () => {
                            await globalStore.syncAllOwnerShopSubscription(shopId);

                            await globalStore.getShopSetting([shopId]);

                            message.success("更新到期时间成功");

                            instance.destroy();
                        }}
                    >
                        已续费，刷新到期时间
                    </AutoLoadingButton>

                    <AutoLoadingButton
                        type="primary"
                        onClick={async () => {
                            let href = "";

                            if (import.meta.env.VITE_IS_QN) {
                                const token = await getSETokenFromQn();

                                if (EcMarketShopTypes.includes(shop.type)) {
                                    href = `${FD_BASE_URL}/setting/shop/appSubscription/index?shopId=${shop?.id}&_token_=${token}`;
                                } else {
                                    href = `${FD_BASE_URL}/setting/shop?_token_=${token}`;
                                }
                            } else {
                                if (EcMarketShopTypes.includes(shop.type)) {
                                    href = `${FD_BASE_URL}/setting/shop/appSubscription/index?shopId=${shop?.id}`;
                                } else {
                                    href = `${FD_BASE_URL}/setting/shop`;
                                }
                            }

                            window.open(href, "_blank");
                        }}
                    >
                        去续费
                    </AutoLoadingButton>
                </div>
            </div>
        ),
        okButtonProps: {
            hidden: true,
        },
        cancelButtonProps: {
            hidden: true,
        },
    });
}

export function showRenewUpgradeModal(data: ShopExpiredResponseData) {
    const shopId = data?.shopId;
    const shopSetting = globalStore.shopSettingMapping.get(shopId);
    const url = getSubscribeUrlByShopSetting(shopSetting);

    const props = {
        title: `店铺【${shopSetting?.name}】已过期，请续费后再来升级`,
        okCancel: true,
        okText: "去订购",
        cancelText: "取消",
    };

    if (url) {
        Modal.info({
            ...props,
            okButtonProps: {
                href: url,
                target: "_blank",
            },
        });
    } else {
        Modal.info({
            ...props,
            okButtonProps: {
                href: `/setting/shop/appSubscription/index?shopId=${shopId}`,
            },
        });
    }
}

export function showShopPremiumModal(originalErrorMessage: string, shopId?: number, type?: PremiumFunctionType) {
    let shop: ShopDTO = undefined;

    // 如果没有shopId 则尝试从错误信息中提取店铺
    if (!shopId) {
        const match = /【(.+?)】店铺/.exec(originalErrorMessage);

        const shopName = match && match[1];

        shop = globalStore.shops.find((shop) => shop.name === shopName);

        shopId = shop?.id;
    } else {
        shop = globalStore.shopMapping.get(shopId);
    }

    const shopName = shop?.name;
    const ownerShop = globalStore.shopMapping.get(shop?.ownerShopId);

    const ownerShopName = ownerShop?.name;

    // 限制高级版
    const content = ownerShop ? (
        <span className="text-error">
            【{shopName}】{shop?.sellerUsername}店铺所属店铺为【{ownerShopName}】店铺，升级【{ownerShopName}】店铺即可
        </span>
    ) : null;

    const instance = Modal.info({
        title: <span className="mt20">{originalErrorMessage}</span>,
        closable: true,
        content: (
            <div>
                {content}

                <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "-20px", marginTop: 40 }}>
                    {shopId ? (
                        <AutoLoadingButton
                            className="mr10"
                            onClick={async () => {
                                const result = await syncShopSubscription(shopId);

                                globalStore.shopAppVersionMapping.set(shopId, {
                                    id: shopId,
                                    appVersion: result.appVersion,
                                });

                                message.success("更新版本成功");

                                instance.destroy();
                            }}
                        >
                            已订高级版，更新版本
                        </AutoLoadingButton>
                    ) : null}

                    <Button
                        type="primary"
                        onClick={() => {
                            window["showUpgradePremiumModal"]?.({
                                shopId,
                                type,
                                fromFeature: type,
                            });

                            instance.destroy();
                        }}
                    >
                        升级版本
                    </Button>
                </div>
            </div>
        ),
        okButtonProps: {
            hidden: true,
        },
        cancelButtonProps: {
            hidden: true,
        },
    });
}

export async function showShopOrderVolumeLimitExceededModal(originalErrorMessage: string, shopId: number) {
    /** 如果shopId的信息,尝试从message中读取 */
    if (!shopId) {
        const match = /^shop\[(\d+?)\]/.exec(originalErrorMessage);

        const shopIdStr = match && match[1];

        if (shopIdStr && Number(shopIdStr)) {
            shopId = Number(shopIdStr);
        }
    }

    if (!shopId) {
        // 适配千牛端后端未返回shopId，手动从错误信息中提取店铺名称后找到shopId
        // 匹配形如 “淘宝店铺[czy777657(淘宝)]订单量超出限” 的正则匹配 提取 -> “czy777657(淘宝)”
        const match = /店铺\[(.+?)(\(.+?\)){0,}]/.exec(originalErrorMessage);

        const shopName = match && match[1];

        if (shopName) {
            const shop = globalStore.shops.find((shop) => shop.name === shopName || shop.sellerUsername === shopName);

            if (shop) {
                shopId = shop.id;
            }
        }
    }

    if (!shopId) {
        // 适配千牛端后端未返回shopId，手动从错误信息中提取店铺名称后找到shopId
        // 匹配:【tb347721479757】店铺是高级版，当前自然月最多可保存30000个订单，当前剩余可保存新订单量为-193个，可按单量付费继续使用，如有疑问可联系客服咨询
        const match = /【(.*?)】店铺/.exec(originalErrorMessage);
        const shopName = match && match[1];

        if (shopName) {
            const shop = globalStore.shops.find((shop) => shop.name === shopName || shop.sellerUsername === shopName);

            if (shop) {
                shopId = shop.id;
            }
        }
    }

    if (!shopId) {
        showErrorModal("错误信息", originalErrorMessage);

        return;
    }

    const shop = globalStore.shopMapping.get(shopId)!;

    if (!shop) {
        showErrorModal("错误信息", originalErrorMessage);

        return;
    }

    await globalStore.getShopSetting([shopId]);
    const shopSetting = globalStore.shopSettingMapping.get(shopId)!;
    const appVersion = shopSetting?.appVersion;
    const totalOrders = shopSetting?.totalOrders;

    const orderVolumeTipName = getOrderVolumeTipName(shop.type);

    // 如果不是高级版，优先让用户升级高级版本
    if (appVersion !== AppVersion.PREMIUM) {
        if (shop.type === ShopType.MANUAL) {
            /**
             * 2025/12/08前，如果手工录入订单超过单量，是直接返回10001的错误码，但是现在后端统一代码逻辑，
             * 10001都是标准版使用高级版功能时抛出的异常
             * 10001都是订单超量的提示
             * 这里使用ShopPremiumModal弹窗的原因是要提示【升级所属的店铺】
             */
            showShopPremiumModal(originalErrorMessage, shop.id);
        } else {
            const instance = Modal.info({
                title: (
                    <span className="mt20">
                        【{ShopTypeNameMap[shop.type]}】【{shop.name}】{shop?.sellerUsername}店铺是
                        {AppVersionNameMap[appVersion]}
                        ，每自然月最多{orderVolumeTipName}
                        {getOrderVolumeLimit(shop.type, appVersion)}
                        个订单，{totalOrders ? `当前已同步${totalOrders}单，` : ""}升级成高级版后每自然月可
                        {orderVolumeTipName}
                        {getOrderVolumeLimit(shop.type, AppVersion.PREMIUM)}
                        个订单。欢迎【{shop.name}】店铺补差价升级后使用。
                    </span>
                ),
                closable: true,
                content: (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginBottom: "-20px",
                            marginTop: 40,
                            width: "100%",
                        }}
                    >
                        {shopId ? (
                            <AutoLoadingButton
                                className="mr10"
                                onClick={async () => {
                                    const result = await syncShopSubscription(shopId);

                                    globalStore.shopAppVersionMapping.set(shopId, {
                                        id: shopId,
                                        appVersion: result.appVersion,
                                    });

                                    message.success("更新版本成功");

                                    instance.destroy();
                                }}
                            >
                                已订高级版，更新版本
                            </AutoLoadingButton>
                        ) : null}

                        <Button
                            type="primary"
                            onClick={() => {
                                window["showUpgradePremiumModal"]?.({
                                    shopId,
                                });

                                instance.destroy();
                            }}
                        >
                            升级版本
                        </Button>
                    </div>
                ),
                okButtonProps: {
                    hidden: true,
                },
                cancelButtonProps: {
                    hidden: true,
                },
            });
        }
    }
    // 如果已经是高级版用户，则让其去付费订购按量付费
    else {
        if ([ShopType.TAOBAO, ShopType.TAOBAO_DISTRIBUTION].includes(shop.type)) {
            await syncTbPrePaidAccountOrder(shopId);
        } else {
            // 进行同步操作
            await syncFirstPagePrepaidAccountPaymentStatus(shopId);
        }

        // 先判断是否有余额
        const account = await getPrepaidAccount(shopId);

        // 余额大于
        if (account?.balance > 0) {
            const quantity = findOrderVolumeBestQuantity(shop.type, account.balance);

            // 可购买数量大于0时，提示用户可直接购买
            if (quantity > 0) {
                Modal.info({
                    title: `您之前已在发货易内充值过，余额为${(account.balance / 100).toFixed(
                        2,
                    )}元，可直接购买订单同步数量${quantity}万单，无需额外支付`,
                    okCancel: true,
                    okText: "直接购买",
                    async onOk() {
                        await purchaseOrderVolume(shopId, quantity);

                        Modal.success({
                            title: "购买成功",
                            content: "预付款账户余额增购订单量成功",
                        });
                    },
                });

                return;
            }
        }

        const instance = Modal.info({
            title: (
                <span className="mt20">
                    【{ShopTypeNameMap[shop.type]}】【{shop.name}】{shop?.sellerUsername}店铺是高级版，每自然月最多可
                    {orderVolumeTipName}
                    {getOrderVolumeLimit(shop.type, appVersion)}
                    个订单，当前已{orderVolumeTipName}
                    {totalOrders}单，可按量付费继续{orderVolumeTipName}订单。欢迎【{shop.name}】店铺按量付费后使用。
                </span>
            ),
            closable: true,
            content: (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginBottom: "-20px",
                        marginTop: 40,
                    }}
                >
                    {shopId ? (
                        <Button
                            className="mr10"
                            onClick={() => {
                                instance.destroy();
                            }}
                        >
                            取 消
                        </Button>
                    ) : null}

                    <Button
                        type="primary"
                        onClick={() => {
                            globalStore.modalStore.openModal(OrderVolumePurchaseModal, {
                                shopId,
                            });

                            instance.destroy();
                        }}
                    >
                        去付费
                    </Button>
                </div>
            ),
            okButtonProps: {
                hidden: true,
            },
            cancelButtonProps: {
                hidden: true,
            },
        });
    }
}

export function showUnrecognizableTableHeaderErrorModal() {
    Modal.error({
        title: "对账表格表头无法识别，请联系客服并提供表格，发货易会尽快为你适配文件进行识别",
        okText: "联系客服",
        okCancel: true,
        cancelText: "关闭",
        onOk() {
            openUrl("https://v2.fahuoyi.com/cs");
        },
    });
}
